import React from "react";
import { Form } from "antd";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import CaseDecisionTypeForm from "./CaseDecisionTypeForm";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
interface CaseDecisionTypeGridProps {
  translate: any;
  caseDecisionTypes: IDocumentType[];
  createCaseDecisionType: any;
  referenceLoader?: boolean;
  updateCaseDecisionType;
}
const CaseDecisionTypeGrid: React.FC<CaseDecisionTypeGridProps> = ({
  translate,
  caseDecisionTypes,
  createCaseDecisionType,
  referenceLoader,
  updateCaseDecisionType
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.case_decisions.types"
  });
  const columns = builder.buildColumns("code", "name", "description", {
    name: "valid",
    dataKey: "valid",
    sortable: false,
    align: "center",
    render: (record) => <TickBox value={record.valid} />
  });

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      title={translate("editors.case_decisions.types.title")}
      columns={columns}
      translate={translate}
      dataSource={caseDecisionTypes || []}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("editors.case_decisions.types.add_new_text")}
      createForm={
        <CaseDecisionTypeForm translate={translate} form={CreateForm} />
      }
      updateForm={
        <CaseDecisionTypeForm translate={translate} form={UpdateForm} />
      }
      createModalTitle={`${translate(
        "editors.case_decisions.types.create_modal_title"
      )}`}
      updateModalTitle={`${translate(
        "editors.case_decisions.types.update_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createCaseDecisionType(e);
      }}
      onUpdate={updateCaseDecisionType}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"code"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
    />
  );
};
export default CaseDecisionTypeGrid;
